export default "__VITE_ASSET__07d3d8a6__"